"use strict";

var LoggerInstance = require("js-logger").get("EventRegistrationHelper");

var AccountFormHelper = require("../accountComponents/AccountFormHelper");
var SmartyStreets = require("../accountComponents/SmartyStreets");
var PledgeStatementHelper = require("../accountComponents/PledgeStatementHelper");

var ActionsHelper = require("../actions/ActionsHelper");

var CheckoutApi = require("../checkoutComponents/CheckoutApi");

var Spinner = require("../client/Spinner");

var ValidationHelper = require("../commonComponents/ValidationHelper");

var WizardConstants = require("../constants/WizardConstants");

var Constants = require("../designer/Constants");

var BootstrapPrompt = require("../shared/BootstrapPrompt");
var HtmlHelper = require("../shared/HtmlHelper");
var LinkMessageHelper = require("../shared/LinkMessageHelper");

var StoresHelper = require("../stores/StoresHelper");

var EventRegistrationHelper = {
	addRegistrant: function(event) {
		event = this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper("addRegistrant"));
		if (!event) {
			return false;
		}

		var components = [
			$("[data-component='eventRegistration']")
		];

		Spinner.showSpinner();
		ValidationHelper.validate({ components }).always(isValid => {
			if (!isValid) {
				LoggerInstance.error("Validation Failed to add registrant in EventRegistrationHelper.");
				Spinner.removeSpinner();
				return false;
			}

			this.verifySmartyStreets().done(() => {
				//Duplicate the single registration HTML
				$("[data-component='singleRegistration']").last().after($(this.singleEventRegistrationHtml));
				var $lastSingleRegistration = $("[data-component='singleRegistration']").last();
				//Correct the registration number
				$lastSingleRegistration.attr("data-registrant-number", Number($lastSingleRegistration.prev().attr("data-registrant-number") || 0) + 1);

				//Reset all Ids because this is repeated content
				this._resetIdsForRepeatedComponents($lastSingleRegistration);

				//If we have react components, we need to initialize them
				this._addReactScriptsForSingleRegistration($lastSingleRegistration, this.reactScriptsForSingleRegistration);

				//Initialize events
				this.initializeSingleRegistration($lastSingleRegistration);

				//Making sure it is in view, scrolling to where the to is at half the page if it's below there.
				//The new scrollTop is the top of the new registration minus twice the window height
				var newScrollPosition = $lastSingleRegistration.offset().top - ($(window).height() / 2);
				if ($(document).scrollTop() < newScrollPosition) {
					$("html, body").animate({scrollTop: newScrollPosition}, 500);
				}
				this._calculateTotal();
				Spinner.removeSpinner();
			}).fail(() => {
				Spinner.removeSpinner();
			});
		});
		return false;
	},

	addToCart: function (event) {
		if (!ActionsHelper.getEventOrReturn(event, /*isDesignMode*/false)) {
			return false;
		}

		var isInPledgeStatementSession = this.isInPledgeStatementSession;
		var pledgeStatementEntryWizard = this[WizardConstants.WIZARDS.PLEDGE_STATEMENT_ENTRY];

		PledgeStatementHelper.confirmAbandonPledgeStatementSession(isInPledgeStatementSession, pledgeStatementEntryWizard).done(() => {
			try {
				//Validation
				var components = [
					$("[data-component='eventRegistration']")
				];
				Spinner.showSpinner();
				ValidationHelper.validate({ components }).always(isValid => {
					if (!isValid) {
						LoggerInstance.error("Validation Failed to add to cart in EventRegistrationHelper.");
						Spinner.removeSpinner();
						return false;
					}

					this.verifySmartyStreets().done(() => {
						var shoppingCartData = this.getShoppingCartData();
						CheckoutApi.addToCart({ cartItems: shoppingCartData }).done((addToCartResponse) => {
							if (addToCartResponse.success) {
								//Unlike the other addToCart buttons, the event addToCart button is only available on the event detail page and there are no options to go anywhere else but the shopping cart page.
								window.location = "/shoppingcart";
							} else if (addToCartResponse.message) {
								//This should be a constituent-safe message
								BootstrapPrompt.alert(addToCartResponse.message);

								//Remove group code if it is a group code error
								if (addToCartResponse.message === StoresHelper.getWizardValue(
									this[WizardConstants.WIZARDS.EVENT_REGISTRATION_DISPLAY_MESSAGES],
									WizardConstants.EVENT_REGISTRATION_DISPLAY_MESSAGES_Fields.ADD_TO_CART_GROUP_CODE_ERROR
								)) {
									this.removeGroupCode(/*event*/ null, /*calledFromAddToCart*/ true);
								}

								Spinner.removeSpinner();
							} else {
								BootstrapPrompt.alert(StoresHelper.getWizardValue(
									this[WizardConstants.WIZARDS.SHOPPING_CART_MESSAGES],
									WizardConstants.SHOPPING_CART_MESSAGE_FIELDS.ADD_TO_CART_ERROR,
									{ tangibleType: "event" }
								));
								Spinner.removeSpinner();
							}
						}).fail(() => {
							BootstrapPrompt.alert(StoresHelper.getWizardValue(
								this[WizardConstants.WIZARDS.SHOPPING_CART_MESSAGES],
								WizardConstants.SHOPPING_CART_MESSAGE_FIELDS.ADD_TO_CART_ERROR,
								{ tangibleType: "event" }
							));
							Spinner.removeSpinner();
						});
					}).fail(() => Spinner.removeSpinner());
				});
			} catch (exception) {
				LoggerInstance.error(exception);
				Spinner.removeSpinner();
			}
			return false;
		});
	},

	applyGroupCode: function (event) {
		event = this._getEventOrReturn(event, "Apply Group Code successfully called.");
		if (!event) {
			return false;
		}

		var $groupCodeInput = $(event.target).find("[data-component='applyGroupCodeForm.input']")

		var groupCode = $groupCodeInput.val();

		// If they didn't enter a group code, don't try and process it.
		if (!groupCode) {
			BootstrapPrompt.alert(StoresHelper.getWizardValue(
				this[WizardConstants.WIZARDS.EVENT_REGISTRATION_DISPLAY_MESSAGES],
				WizardConstants.EVENT_REGISTRATION_DISPLAY_MESSAGES_Fields.APPLY_GROUP_CODE_ERROR
			));
			return false;
		}

		//Clear the current group code input
		$groupCodeInput.val("");

		// Check to see if the group code is valid
		CheckoutApi.getGroupCodeData({
			groupCode: groupCode,
			eventCode: window.tangibleCode
		}).done((data) => {
			if (data.isValidGroupCode) {
				this._updateGroupCodeUi(groupCode, data);

				this._updateAllPrices();

				CheckoutApi.removeGroupCodeCookie();
			} else {
				BootstrapPrompt.alert(StoresHelper.getWizardValue(
					this[WizardConstants.WIZARDS.EVENT_REGISTRATION_DISPLAY_MESSAGES],
					WizardConstants.EVENT_REGISTRATION_DISPLAY_MESSAGES_Fields.APPLY_GROUP_CODE_ERROR
				));
			}
		}).fail(() => {
			BootstrapPrompt.alert(StoresHelper.getWizardValue(
				this[WizardConstants.WIZARDS.EVENT_REGISTRATION_DISPLAY_MESSAGES],
				WizardConstants.EVENT_REGISTRATION_DISPLAY_MESSAGES_Fields.APPLY_GROUP_CODE_ERROR
			));
		});

		return false;
	},

	getShoppingCartData: function() {
		var eventRegistrationData = {
			eventCode: window.tangibleCode,
			registrants: [
			]
		};

		var isThisIsMeAlreadyProcessed = false;
		$("[data-component='singleRegistration']").each((index, element) => {
			var $element = $(element);
			var $individualRegistration = $element.find("[data-component='individualRegistration']");
			var $spouseRegistration = $element.find("[data-component='spouseRegistration']");
			var $selectedPriceCodeOption = $element.find("[data-component='singleRegistrationPriceCode.selector']").first().find("option:selected");
			var $createAccountForm = $individualRegistration.find("[data-component='createAccountForm']");
			var groupCode = $("[data-component='applyGroupCodeForm']").attr("group-code");
			var groupCodePriceCode = $("[data-component='applyGroupCodeForm']").attr("group-code-price-code");
			var isThisIsMeIsChecked = $element.find("[data-component='thisIsMeCheckbox'] input").first().is(":checked");

			var individualRegistrationData = AccountFormHelper.serializeCreateAccountFormOnly({
				accountFormId: $createAccountForm.attr("id")
			});

			//Get account demographics for the Individual Registrant (we only want to get them once for all the thisIsMeCheckbox registrants)
			if (!isThisIsMeIsChecked || !isThisIsMeAlreadyProcessed) {
				AccountFormHelper.updateAccountDemographics(individualRegistrationData, $individualRegistration);
			}

			var individualSessions = $individualRegistration.find("[data-component='eventRegistrationSessions.singleCheckbox.input']:checked").map((mapIndex, individualSession) => {
				var $individualSession = $(individualSession);
				return {
					priceCode: $individualSession.attr("data-price-code"),
					sessionCode: $individualSession.attr("name")
				};
			}).toArray();
			var spouseRegistrationData = ActionsHelper.serializeForm($spouseRegistration.find("[data-component='spouseInformation'] form"));

			//Get account demographics for the Spouse Registrant (we only want to get them once for all the thisIsMeCheckbox registrants)
			if (!isThisIsMeIsChecked || !isThisIsMeAlreadyProcessed) {
				AccountFormHelper.updateAccountDemographics(spouseRegistrationData, $spouseRegistration);
			}

			var spouseSessions = $spouseRegistration.find("[data-component='eventRegistrationSessions.singleCheckbox.input']:checked").map((mapIndex, spouseSession) => {
				var $individualSession = $(spouseSession);
				return {
					priceCode: $individualSession.attr("data-price-code"),
					sessionCode: $individualSession.attr("name")
				};
			}).toArray();

			//Making sure we get the email address value.  It works a bit differently because it is always disabled when thisIsMe is checked.
			var data = this._serializeEmailAddress({
				individual: individualRegistrationData,
				spouse: spouseRegistrationData
			}, $element);
			individualRegistrationData = data.individual;
			spouseRegistrationData = data.spouse;

			var registrant = {
				groupCode: groupCode,
				groupCodePriceCode: groupCodePriceCode,
				priceCode: $selectedPriceCodeOption.attr("data-price-code") || this.initialPriceCode,
				thisIsMeChecked: isThisIsMeIsChecked
			};

			isThisIsMeAlreadyProcessed = isThisIsMeAlreadyProcessed || isThisIsMeIsChecked;

			if (Object.keys(individualRegistrationData).length) {
				registrant.individualData = individualRegistrationData;
			}
			if (individualSessions.length) {
				registrant.individualSessions = individualSessions;
			}

			if (($selectedPriceCodeOption.attr("data-price-type") || this.initialPriceType) === "couple") {
				if (Object.keys(spouseRegistrationData).length) {
					registrant.spouseData = spouseRegistrationData;
				}
				if (spouseSessions.length) {
					registrant.spouseSessions = spouseSessions;
				}
			}

			eventRegistrationData.registrants.push(registrant);
		});
		return { events: [eventRegistrationData] };
	},

	initialize: function(options) {
		options = options || {};
		this[WizardConstants.WIZARDS.EVENT_REGISTRATION_DISPLAY_MESSAGES] = options[WizardConstants.WIZARDS.EVENT_REGISTRATION_DISPLAY_MESSAGES] || {};
		this[WizardConstants.WIZARDS.PLEDGE_STATEMENT_ENTRY] = options[WizardConstants.WIZARDS.PLEDGE_STATEMENT_ENTRY] || {};
		this[WizardConstants.WIZARDS.SHOPPING_CART_MESSAGES] = options[WizardConstants.WIZARDS.SHOPPING_CART_MESSAGES] || {};
		this.initialPrice = options.initialPrice;
		this.initialPriceCode = options.initialPriceCode;
		this.initialPriceDescription = options.initialPriceDescription;
		this.initialPriceType = options.initialPriceType;
		this.isInPledgeStatementSession = options.isInPledgeStatementSession;

		this.accountData = options.accountData;

		if (this.accountData) {
			this.accountData.codes = window.AccountActions.getAccountCodes() || [];
		}

		this.spouseData = options.spouseData;

		if (this.spouseData) {
			this.spouseData.codes = options.spouseAccountCodes;
		}

		this.savedThisIsMeValues = {};

		var groupCode = options.groupCode;

		//Initialize AddToCart Buttons
		var $addToCartButtons = $("[data-component='addEventToCartButton']");
		$addToCartButtons.off("click.eventRegistration");
		$addToCartButtons.on("click.eventRegistration", (event) => this.addToCart(event));

		//We need to save the event registration component html so that it can be duplicated.  We only allow a single one on the page.
		var $singleRegistration = $("[data-component='singleRegistration']").first().attr("data-registrant-number", 1);
		if ($singleRegistration[0] != null) {
			//If update is now allowed, we record this fact.  Then we set the update-allowed attribute so that the fields will be enabled by default.
			var $firstCreateAccountForm = $singleRegistration.find("[data-component='createAccountForm']").first();
			this.accountUpdateAllowed = $firstCreateAccountForm.is("[data-update-allowed]");
			this.spouseUpdateAllowed = this.accountUpdateAllowed;

			//If we are Unidentified, we want to allow updating data.
			if (!this.accountData) {
				this.accountUpdateAllowed = true;
			}
			if (!this.spouseData) {
				this.spouseUpdateAllowed = true;
			}

			$firstCreateAccountForm.attr("data-update-allowed", true);

			//For any Account Demographic Select component that has a default value that was selected, set the select input to have the isDirty class
			$singleRegistration
				.find("[data-component='select'][data-code-type-default-value] select[data-parent-form-component='accountDemographicsForm']:has(option[selected])")
				.addClass("isDirty");

			//Wrapping accountDemographicsForm components in an HTML form if they are not wrapped in one already.
			//	This is mainly to ensure that radio buttons for each registrant are in their own group and not all together in a single group across the page.
			$singleRegistration.find("[data-component='accountDemographicsForm']").not("form [data-component='accountDemographicsForm']").wrap("<form></form>")

			this.singleEventRegistrationHtml = $singleRegistration[0].outerHTML;

			//Reset all Ids because this is repeated content
			this._resetIdsForRepeatedComponents($singleRegistration);

			//If there is a query param groupCode, then update the UI
			//Only apply it if there is an apply group code form
			if (groupCode && $("[data-component='applyGroupCodeForm']").length) {
				CheckoutApi.getGroupCodeData({
					groupCode: groupCode,
					eventCode: window.tangibleCode
				}).done((data) => {
					if (data.isValidGroupCode) {
						this._updateGroupCodeUi(groupCode, data);

						this._updateAllPrices();
					} else {
						//Invalid group code, so hide the current group code components
						$("[data-component='currentGroupCode']").hide();
					}
				}).fail(() => {
					//Invalid group code, so hide the current group code components
					$("[data-component='currentGroupCode']").hide();
				});
			}

			$(document).ready(() => {
				this.reactScriptsForSingleRegistration = this._getReactScriptForSingleRegistration(this.singleEventRegistrationHtml);
				this.initializeSingleRegistration();

				var $firstThisIsMe = $singleRegistration.find("input[data-component='thisIsMeCheckbox.input']").first();
				if ($singleRegistration.find("[data-component='thisIsMeCheckbox']").attr("data-is-first-checked-by-default") === "true") {
					if ($firstThisIsMe.is(":checked")) {
						//Uncheck and then check again to make sure the appropriate events were triggered
						$firstThisIsMe.click();
					}
					$firstThisIsMe.click();
				} else if ($firstThisIsMe.is(":checked")) {
					//It was checked, but it shouldn't be
					$firstThisIsMe.click();
				}
			});
		}
		if (!groupCode) {
			//We already update the total if we have a group code
			this._calculateTotal();

			//Hide any existing current group code components
			$("[data-component='currentGroupCode']").hide();
		}

		this.initializeGroupCode();
	},

	initializeGroupCode: function() {
		var $applyGroupCodeForms = $("[data-component=applyGroupCodeForm]");
		$applyGroupCodeForms.each((index, element) => {
			var $element = $(element);

			var $groupCodeForm = $element.find(`form#applyGroupCodeForm`).first();

			$groupCodeForm.on("submit.applyGroupCodeForm", (event) => {
				EventRegistrationHelper.applyGroupCode(event);
			});

			//Update form id
			var componentId = $element.attr("id");

			// We need to make the form id and the submit button form attributes unique.
			var formId = $groupCodeForm.attr("id");
			var $submitButton = $groupCodeForm.find("[data-component='submitButton']");

			var newId = `${formId}_${componentId}`;

			$groupCodeForm.attr("id", newId);
			$submitButton.attr("form", newId);
		});
	},

	initializeSingleRegistration: function($singleRegistration) {
		//initializing the singleRegistrationPriceCode
		$singleRegistration = $($singleRegistration || "[data-component='singleRegistration']");

		var $priceCodeSelectors = $singleRegistration.find("[data-component='singleRegistrationPriceCode.selector']");
		$priceCodeSelectors.each((index, element) => {
			var $element = $(element);
			this._priceCodeChange($element, $singleRegistration);
			$element.off("change.singleRegistrationPriceCode");
			$element.on("change.singleRegistrationPriceCode", () => this._priceCodeChange($element));
		});

		if (!$priceCodeSelectors.length) {
			//There is no price code selector, so let's set the client data
			this._priceCodeChange($(null), $singleRegistration);
			this._setClientDynamicData($singleRegistration);
		}

		//InitializePhoneNumberInput for Individual and Spouse
		var defaultCountry = ((this.accountData || {}).address || {}).country;
		window.AccountActions.initializePhoneNumberGroupComponent(defaultCountry, $singleRegistration.find("[data-component='individualRegistration']"));

		var $spouseRegistration = $singleRegistration.find("[data-component='spouseRegistration']");
		if ($spouseRegistration.length) {
			window.AccountActions.initializePhoneNumberGroupComponent(defaultCountry, $spouseRegistration);
		}

		//initializing the thisIsMeCheckbox component
		$singleRegistration.find("[data-component='thisIsMeCheckbox']").each((index, checkbox) => {
			var $checkbox = $(checkbox);
			var $input = $checkbox.find("[data-component='thisIsMeCheckbox.input']");
			//Remove the for attribute on the label because the whole thisIsMeCheckbox is selectable
			$checkbox.find("label[data-child-of='thisIsMeCheckbox']").removeAttr("for");
			//Adding the click event listener
			$input.off("click.thisIsMe");
			$input.on("click.thisIsMe", (event) => {
				this.thisIsMeSelected(event, $input);
			});

			$checkbox.off("click.thisIsMe");
			$checkbox.on("click.thisIsMe", (event) => {
				if ($input.is(":disabled")) {
					return;
				}
				$input.prop("checked", !$input.prop("checked"));
				this.thisIsMeSelected(event, $input);
			});

			$checkbox.find("*").add($checkbox).css("cursor", "pointer");
		});

		//initializing the session checkboxes
		$singleRegistration.find("[data-component='eventRegistrationSessions.singleCheckbox']").each((index, checkbox) => {
			var $checkbox = $(checkbox);
			var $input = $checkbox.find("[data-component='eventRegistrationSessions.singleCheckbox.input']");
			//Setting the for attribute on the label
			$checkbox.find("label[data-input-label]").attr("for", $input.attr("id"));
			//Adding the click event listener
			$input.off("click.sessionCheckbox");
			$input.on("click.sessionCheckbox", () => {
				this._calculateTotal();
			});
		});

		//Set up listeners so that when any thisIsMeCheckbox is checked, all of the account data from the linked single registration components is synced up
		var $elements = $singleRegistration.find("[data-component='createAccountForm'] input,[data-component='spouseInformation'] input").not("input[data-parent-form-component='accountDemographicsForm']");
		$elements.off("blur.thisIsMeAccountData");
		$elements.on("blur.thisIsMeAccountData", this._accountDataChanged);

		$elements = $singleRegistration.find(
			"[data-component='createAccountForm'] select," +
			"[data-component='spouseInformation'] select," +
			"select[data-parent-form-component='accountDemographicsForm']," +
			//Handle Account Demographics checkboxes and radio buttons using a change listener
			"input[data-parent-form-component='accountDemographicsForm']:checkbox," +
			"input[data-parent-form-component='accountDemographicsForm']:radio"
		);
		$elements.off("change.thisIsMeAccountData");
		$elements.on("change.thisIsMeAccountData", this._accountDataChanged);

		//Set up listeners on the Account Demographics inputs
		window.AccountActions.initializeDemographics({
			accountCodes: [],
			parentSelector: $singleRegistration
		});

		//Just in case there is an AddToCart button inside a singleRegistration.
		var $addToCartButtons = $singleRegistration.find("[data-component='addEventToCartButton']");
		$addToCartButtons.off("click.eventRegistration");
		$addToCartButtons.on("click.eventRegistration", (event) => this.addToCart(event));

		SmartyStreets.initializeForEventRegistration($singleRegistration.find("[data-component='createAccountForm']").attr("id"));
	},

	removeGroupCode: function(event, calledFromAddToCart) {
		event = this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper("removeGroupCodeLink"));
		if (!event && !calledFromAddToCart) {
			return false;
		}

		if ($("[data-component='applyGroupCodeForm']").attr("group-code")) {
			//Clear the current group code.
			$("[data-component='applyGroupCodeForm']").removeAttr("group-code");
			$("[data-component='applyGroupCodeForm']").removeAttr("group-code-price-code");
			$("[data-component='applyGroupCodeForm.input']").val("");

			//If there is a current groupCode component, hide it
			$("[data-component='currentGroupCode']").hide();

			var $registrationTypes = $("[data-component='singleRegistrationPriceCode.selector'] option");

			//Update each registration drop-down with the original
			$registrationTypes.each((index, singlePriceSelector) => {
				var $singlePriceSelector = $(singlePriceSelector);
				var newPriceDescription = $singlePriceSelector.html();
				var originalPrice = $singlePriceSelector.attr("data-old-price");

				if (originalPrice) {
					newPriceDescription = this._getNewPriceCodeDescription($singlePriceSelector, originalPrice);

					$singlePriceSelector.html(newPriceDescription);
					$singlePriceSelector.attr("data-price", originalPrice);
					$singlePriceSelector.removeAttr("data-old-price");
				}
			});

			this._updateAllPrices();

			CheckoutApi.removeGroupCodeCookie();
		}

		return false;
	},

	removeRegistrant: function(event) {
		event = this._getEventOrReturn(event, LinkMessageHelper.linkMessageMapper("removeRegistrant"));
		if (!event) {
			return false;
		}

		BootstrapPrompt.confirm({
			btnCancelLabel: window.BUTTON_LABELS.NO,
			btnOKLabel: window.BUTTON_LABELS.YES,
			message: StoresHelper.getWizardValue(
				this[WizardConstants.WIZARDS.EVENT_REGISTRATION_DISPLAY_MESSAGES],
				WizardConstants.EVENT_REGISTRATION_DISPLAY_MESSAGES_Fields.DELETE_REGISTRANT
			)
		}, (result) => {
			if (result) {
				var $singleRegistration = $(event.target).closest("[data-component='singleRegistration']");
				var $eventRegistration = $singleRegistration.closest("[data-component='eventRegistration']");
				var $firstCheckboxInput = $singleRegistration.find("input[data-component='thisIsMeCheckbox.input']").first();
				var $allCheckedCheckboxInputs = $eventRegistration.find("input[data-component='thisIsMeCheckbox.input']:checked");
				if ($eventRegistration.find("[data-component='singleRegistration']").length > 1) {
					//There is more than one registrant, we can go ahead and delete it.
					if ($singleRegistration) {
						//Unmount existing react components
						$singleRegistration.find("[data-react-component-name]").each(function() {
							ReactDOM.unmountComponentAtNode(this.parentElement);
						});

						//If there is a thisIsMeCheckbox component that is checked, we might need to do some things.
						var $thisIsMeInputs = $singleRegistration.find("input[data-component='thisIsMeCheckbox.input']");

						var minimumThisIsMeCheckboxCheckedThatWasNotJustChanged = Number($allCheckedCheckboxInputs.not($thisIsMeInputs).first().closest("[data-component='singleRegistration']").attr("data-registrant-number"));
						var $firstThisIsMeSingleRegistrationThatWasNotJustChanged = $(`[data-component="singleRegistration"][data-registrant-number="${minimumThisIsMeCheckboxCheckedThatWasNotJustChanged}"]`);

						var $singleRegistrationsWithVisibleSpouseRegistration = $allCheckedCheckboxInputs.not($thisIsMeInputs).closest("[data-component='singleRegistration']").filter((index, element) => {
							var $priceCodeSelector = $(element).find("[data-component='singleRegistrationPriceCode.selector']");
							return ($priceCodeSelector.length && $priceCodeSelector.has("option[data-price-type=couple]:selected").length) || this.initialPriceType === "couple";
						});
						var minimumSpouseThisIsMeCheckboxChecked = Number($singleRegistrationsWithVisibleSpouseRegistration.first().attr("data-registrant-number"));
						var $firstSpouseThisIsMeSingleRegistrationThatWasNotJustChanged = $(`[data-component="singleRegistration"][data-registrant-number="${minimumSpouseThisIsMeCheckboxChecked}"]`);

						if ($thisIsMeInputs.is(":checked")) {
							//If thisIsMe is checked.
							//If this is the first one, enable next visible one's fields
							this._setFieldDisableStatus($firstThisIsMeSingleRegistrationThatWasNotJustChanged, "individual", /*isDisabled*/ false);
							this._setFieldDisableStatus($firstSpouseThisIsMeSingleRegistrationThatWasNotJustChanged, "spouse", /*isDisabled*/ false);

							//If update is not allowed, we should set the fields to disabled
							if (!this.accountUpdateAllowed) {
								this._setFieldDisableStatusInForm($firstThisIsMeSingleRegistrationThatWasNotJustChanged, "individual", /*isDisabled*/ true);
							}
							if (!this.spouseUpdateAllowed) {
								this._setFieldDisableStatusInForm($firstSpouseThisIsMeSingleRegistrationThatWasNotJustChanged, "spouse", /*isDisabled*/ true);
							}

							//EmailAddress Field are always disabled when we are identified or logged in because we do not want the constituent's username to change
							this._setEmailFieldAsDisabled($firstThisIsMeSingleRegistrationThatWasNotJustChanged.find("[data-component='individualRegistration']"), $firstSpouseThisIsMeSingleRegistrationThatWasNotJustChanged.find("[data-component='spouseRegistration']"));
						}
						//If thisIsMe is NOT checked, nothing needs to be done

						//Remove any possible SmartyStreets object
						SmartyStreets.removeEventRegistration($singleRegistration.find("[data-component='createAccountForm']").attr("id"));

						//Remove the registrant (and event listeners)
						$singleRegistration.remove();

						//Fixing the registrant numbers
						var registrantNumber = 1;
						$("[data-component='singleRegistration']").each((index, element) => {
							var $singleRegistrationElement = $(element);
							$singleRegistrationElement.attr("data-registrant-number", registrantNumber);
							registrantNumber++;
							this._setClientDynamicData($singleRegistrationElement);
						});

						delete this.savedThisIsMeValues[$singleRegistration.attr("id")];
					}
				} else {
					//There is the only a single registration, just clear the inputs, do not remove
					var $individualRegistration = $singleRegistration.find("[data-component='individualRegistration']");
					var individualFormId = $individualRegistration.find("[data-component='createAccountForm']").attr("id");
					this._clearRegistrationData($individualRegistration, individualFormId, /*shouldDefaultValues*/ true);

					var $spouseRegistration = $singleRegistration.find("[data-component='spouseRegistration']");
					var spouseFormId = $spouseRegistration.find("[data-component='spouseInformation']").attr("id");
					this._clearRegistrationData($spouseRegistration, spouseFormId, /*shouldDefaultValues*/ true);

					delete this.savedThisIsMeValues[$singleRegistration.attr("id")];
					$allCheckedCheckboxInputs.prop("checked", false);

					if ($firstCheckboxInput.closest("[data-component='thisIsMeCheckbox']").attr("data-is-first-checked-by-default") === "true") {
						$firstCheckboxInput.click();
					} else {
						this._setFieldDisableStatus($singleRegistration, "individual", /*isDisabled*/ false);
						this._setFieldDisableStatus($singleRegistration, "spouse", /*isDisabled*/ false);
					}
				}
				this._calculateTotal();
			}
		});
		return false;
	},

	thisIsMeSelected(event, $checkboxInput) {
		if (!event) {
			return;
		}

		if (!$checkboxInput.length || $checkboxInput.is(":disabled")) {
			return;
		}

		//This fixes problems when the thisIsMeCheckbox input itself is checked
		event.stopPropagation();

		var $singleRegistration = $checkboxInput.closest("[data-component='singleRegistration']");
		var $eventRegistration = $singleRegistration.closest("[data-component='eventRegistration']");
		var singleRegistrationId = $singleRegistration.attr("id");
		var $allThisIsMeCheckboxesInSingleRegistration = $singleRegistration.find("input[data-component='thisIsMeCheckbox.input']");
		var $individualRegistration = $singleRegistration.find("[data-component='individualRegistration']");
		var individualFormId = $individualRegistration.find("[data-component='createAccountForm']").attr("id");
		var $spouseRegistration = $singleRegistration.find("[data-component='spouseRegistration']");
		var spouseFormId = $spouseRegistration.find("[data-component='spouseInformation']").attr("id");

		//Set all the other thisIsMeCheckboxes in this singleRegistration to the same as the one that was just checked.
		$allThisIsMeCheckboxesInSingleRegistration.prop("checked", $checkboxInput.is(":checked"));

		var $allCheckedCheckboxInputs = $eventRegistration.find("input[data-component='thisIsMeCheckbox.input']:checked");
		var currentRegistrantNumber = Number($singleRegistration.attr("data-registrant-number"));

		var currentContainsVisibleSpouse = $singleRegistration.filter((index, element) => {
			var $priceCodeSelector = $(element).find("[data-component='singleRegistrationPriceCode.selector']");
			return ($priceCodeSelector.length && $priceCodeSelector.has("option[data-price-type=couple]:selected").length) || this.initialPriceType === "couple";
		});
		var minimumThisIsMeCheckboxCheckedThatWasNotJustChanged = Number($allCheckedCheckboxInputs.not($allThisIsMeCheckboxesInSingleRegistration).first().closest("[data-component='singleRegistration']").attr("data-registrant-number"));
		var $singleRegistrationsWithVisibleSpouseRegistration = $allCheckedCheckboxInputs.not($allThisIsMeCheckboxesInSingleRegistration).closest("[data-component='singleRegistration']").filter((index, element) => {
			var $priceCodeSelector = $(element).find("[data-component='singleRegistrationPriceCode.selector']");
			return ($priceCodeSelector.length && $priceCodeSelector.has("option[data-price-type=couple]:selected").length) || this.initialPriceType === "couple";
		});
		var minimumSpouseThisIsMeCheckboxCheckedThatWasNotJustChanged = Number($singleRegistrationsWithVisibleSpouseRegistration.first().attr("data-registrant-number"));

		if ($checkboxInput.is(":checked")) {
			//Do we have existing data on the form, if so, save it
			//Save previously entered data
			this.savedThisIsMeValues[singleRegistrationId] = this._serializeSingleRegistration($singleRegistration, /*serializeDemographics*/ true);

			//If there are no other This is Me checkboxes that are checked outside of the parent singleRegistration
			if ($allThisIsMeCheckboxesInSingleRegistration.is($checkboxInput) && $allCheckedCheckboxInputs.not($allThisIsMeCheckboxesInSingleRegistration).length == 0) {
				if (this.accountData) {
					//We should not default the inputs because we will populate them from the account data
					this._clearRegistrationData($singleRegistration, individualFormId, /*shouldDefaultValues*/ false);

					//This is the first checkbox input.  If we have account data, set it.
					this._setAccountData(this.accountData, $individualRegistration, individualFormId);
					this._setAccountData(this.spouseData, $spouseRegistration, spouseFormId);
				}
			} else {
				var thisIsMeData = {};

				//Let's copy the fields to the fields where the thisIsMeCheckbox was just checked
				var $firstThisIsMeSingleRegistrationThatWasNotJustChanged = $(`[data-component="singleRegistration"][data-registrant-number="${minimumThisIsMeCheckboxCheckedThatWasNotJustChanged}"]`);
				thisIsMeData = this._serializeSingleRegistration($firstThisIsMeSingleRegistrationThatWasNotJustChanged);
				//Setting the data for the singleRegistration where the thisIsMeCheckbox was just checked.
				this._setAccountData(!this.accountUpdateAllowed && this.accountData ? this.accountData : thisIsMeData.individual, $individualRegistration, individualFormId);
				this._copyDemographics($firstThisIsMeSingleRegistrationThatWasNotJustChanged.find("[data-component='individualRegistration']"), $individualRegistration);
				this._setAccountData(!this.spouseUpdateAllowed && this.spouseData ? this.spouseData : thisIsMeData.spouse, $spouseRegistration, spouseFormId);
				this._copyDemographics($firstThisIsMeSingleRegistrationThatWasNotJustChanged.find("[data-component='spouseRegistration']"), $spouseRegistration);

				//If the thisIsMeCheckbox that was just checked is below another one, we just want to disable the fields
				//This is for the individualRegistration
				if (currentRegistrantNumber > minimumThisIsMeCheckboxCheckedThatWasNotJustChanged) {
					//Disable the fields in the individual registration for the thisIsMeCheckbox that was checked
					this._setFieldDisableStatus($singleRegistration, "individual", /*isDisabled*/ true);
				} else {
					//We just checked a thisIsMeCheckbox above one we already checked.
					//Disable fields for singleRegistration for previously checked thisIsMeCheckbox
					this._setFieldDisableStatus($firstThisIsMeSingleRegistrationThatWasNotJustChanged, "individual", /*isDisabled*/ true);
				}

				if (currentRegistrantNumber > minimumSpouseThisIsMeCheckboxCheckedThatWasNotJustChanged) {
					//Disable spouse fields as we checked a thisIsMeCheckbox below a registrant that already had thisIsMe checked.
					this._setFieldDisableStatus($singleRegistration, "spouse", /*isDisabled*/ true);
				} else if (currentContainsVisibleSpouse) {
					var $firstSpouseThisIsMeSingleRegistrationThatWasNotJustChanged = $(`[data-component="singleRegistration"][data-registrant-number="${minimumSpouseThisIsMeCheckboxCheckedThatWasNotJustChanged}"]`);
					this._setFieldDisableStatus($firstSpouseThisIsMeSingleRegistrationThatWasNotJustChanged, "spouse", /*isDisabled*/ true);
				}
			}

			//If update is not allowed, we should set the fields to disabled
			if (!this.accountUpdateAllowed) {
				this._setFieldDisableStatusInForm($singleRegistration, "individual", /*isDisabled*/ true);
			}
			if (!this.spouseUpdateAllowed) {
				this._setFieldDisableStatusInForm($singleRegistration, "spouse", /*isDisabled*/ true);
			}

			//EmailAddress Field are always disabled when we are identified or logged in because we do not want the constituent's username to change
			this._setEmailFieldAsDisabled($individualRegistration, $spouseRegistration);

			//Need to set the address as verified for SmartyStreets
			$singleRegistration.find("[data-component='createAccountForm'] form")
				.attr(Constants.ADDRESS_VERIFICATION_STATUSES_ATTRIBUTES.VERIFIED, "true")
				.removeAttr(Constants.ADDRESS_VERIFICATION_STATUSES_ATTRIBUTES.USER_CERTIFIED)
				.removeAttr(Constants.ADDRESS_VERIFICATION_STATUSES_ATTRIBUTES.ERROR);
		} else {
			//If this was the first thisIsMeCheckbox checked and there are any more thisIsMeCheckboxes checked,
			if (currentRegistrantNumber < minimumThisIsMeCheckboxCheckedThatWasNotJustChanged && $allCheckedCheckboxInputs.length) {
				//We need to enable the fields to the first singleRegistration where the thisIsMeCheckbox is checked
				var $nextThisIsMeSingleRegistration = $allCheckedCheckboxInputs.first().closest("[data-component='singleRegistration']");

				this._setFieldDisableStatus($nextThisIsMeSingleRegistration, "individual", /*isDisabled*/ false);
				this._setFieldDisableStatus($singleRegistrationsWithVisibleSpouseRegistration, "spouse", /*isDisabled*/ false);

				//If update is not allowed, we should set the fields to disabled
				if (!this.accountUpdateAllowed) {
					this._setFieldDisableStatusInForm($nextThisIsMeSingleRegistration, "individual", /*isDisabled*/ true);
				}
				if (!this.spouseUpdateAllowed) {
					this._setFieldDisableStatusInForm($singleRegistrationsWithVisibleSpouseRegistration, "spouse", /*isDisabled*/ true);
				}

				//EmailAddress Field are always disabled when we are identified or logged in because we do not want the constituent's username to change
				this._setEmailFieldAsDisabled($nextThisIsMeSingleRegistration.find("[data-component='individualRegistration']"), $singleRegistrationsWithVisibleSpouseRegistration.find("[data-component='spouseRegistration']"));
			}

			//Clear the data
			this._clearRegistrationData($individualRegistration, individualFormId, /*shouldDefaultValues*/ true);
			this._clearRegistrationData($spouseRegistration, spouseFormId, /*shouldDefaultValues*/ true);

			var savedFormData = this.savedThisIsMeValues[singleRegistrationId];
			//Do we have previous saved data
			if (savedFormData) {
				this._setAccountData(savedFormData.individual, $individualRegistration, individualFormId);
				this._setAccountData(savedFormData.spouse, $spouseRegistration, spouseFormId);
			}
		}
	},

	verifySmartyStreets: function(ids, deferred) {
		//We could be verifying multiple address components.
		deferred = deferred || new $.Deferred();

		if (ids == null) { //coercion because I want both null and undefined
			ids = $("[data-component='eventRegistration'] [data-component='createAccountForm']").filter((index, element) => {
				return $(element).find("[data-component='accountAddressLine1']:enabled").length;
			}).toArray().map(element => $(element).attr("id"));
		}

		ids = ids || [];
		if (ids.length) {
			SmartyStreets.verifyAddress(`eventRegistration${ids[0]}`).done(() => {
				ids.splice(0, 1);
				this.verifySmartyStreets(ids, deferred);
			}).fail(() => {
				deferred.reject();
			});
		} else {
			deferred.resolve();
		}
		return deferred;
	},

	_accountDataChanged: function(event) {
		if (!event || !event.target) {
			return;
		}

		var $field = $(event.target);
		var $singleRegistration = $field.closest("[data-component='singleRegistration']");

		if (!$singleRegistration.find("input[data-component='thisIsMeCheckbox.input']:checked").length) {
			//This is Me Checkbox is not checked, so we should not need to keep any other input fields in sync
			return;
		}

		//Need to determine if it is a spouse field or not
		var individualOrSpouseRegistrationComponent = $field.closest("[data-component='individualRegistration'],[data-component='spouseRegistration']").attr("data-component");
		var createAccountOrSpouseDataComponent = $field.closest("[data-component='createAccountForm'],[data-component='spouseInformation']").attr("data-component");
		var accountTypeSelector = `[data-component='${createAccountOrSpouseDataComponent}']`;

		var name = $field.attr("name");
		var value = $field.val();

		var $singleRegistrationsWhereThisIsMeIsChecked = $("[data-component='singleRegistration']").not($singleRegistration).has("input[data-component='thisIsMeCheckbox.input']:checked");

		var changeFunction;
		var fieldComponentName = $field.closest("[data-component]").attr("data-component");

		switch (fieldComponentName) {
			case "accountTitle":
				changeFunction = window.AccountActions.setSelectedTitle;
				break;
			case "accountAddressState":
				changeFunction = window.AccountActions.setSelectedState;
				break;
			case "accountAddressCountry":
				changeFunction = window.AccountActions.setSelectedCountry;
				break;
			case "accountEmailType":
				changeFunction = window.AccountActions.setSelectedEmailType;
				break;
			case "accountPhoneType":
				changeFunction = window.AccountActions.setSelectedPhoneType;
				break;
			case "select.input":
				$singleRegistrationsWhereThisIsMeIsChecked.find(
					`[data-component='${individualOrSpouseRegistrationComponent}'] [data-component="${fieldComponentName}"][name="${name}"]`
				).val(value);
				break;
			case "radioButtons.singleRadioButton.input":
				$singleRegistrationsWhereThisIsMeIsChecked.find(
					`[data-component='${individualOrSpouseRegistrationComponent}'] [data-component="${fieldComponentName}"][name="${name}"][value="${value}"]`
				).prop("checked", true);
				break;
			case "singleCheckbox.input":
				var shouldCheck = $field.prop("checked");
				$singleRegistrationsWhereThisIsMeIsChecked.find(
					`[data-component='${individualOrSpouseRegistrationComponent}'] [data-component="${fieldComponentName}"][name="${name}"]`
				).prop("checked", shouldCheck);
				break;
			case "multipleCheckboxes.singleCheckbox.input":
				var shouldCheck = $field.prop("checked");
				$singleRegistrationsWhereThisIsMeIsChecked.find(
					`[data-component='${individualOrSpouseRegistrationComponent}'] [data-component="${fieldComponentName}"][name="${name}"][value="${value}"]`
				).prop("checked", shouldCheck);
				break;
			default:
				$singleRegistrationsWhereThisIsMeIsChecked.find(
					`${accountTypeSelector} [data-component="${fieldComponentName}"]`
				).val(value);
		}

		if (changeFunction) {
			_.defer(() => {
				$singleRegistrationsWhereThisIsMeIsChecked.each((index, element) => {
					var formId = $(element).find(accountTypeSelector).attr("id");
					changeFunction(formId, value);
				});
			});
		}
	},

	_addReactScriptsForSingleRegistration: function($lastSingleRegistration, reactScriptsForSingleRegistration) {
		var $reactComponents = $lastSingleRegistration.find(".isReactComponent");
		if ($reactComponents.length && reactScriptsForSingleRegistration) {
			var scriptToAdd = "";
			//We need to find and rerun the scripts to mount the react components.
			$reactComponents.each((index, element) => {
				var newScript = (reactScriptsForSingleRegistration.filter(singleLineScript => {
					return singleLineScript.includes(element.id);
				}) || [""])[0];

				if (newScript) {
					//Changing out the reactId
					var newElementId = `${element.id}${this.registrationNumber}`;
					newScript = newScript.replace(element.id, newElementId);
					element.id = newElementId;

					scriptToAdd = `${scriptToAdd}\n${newScript}`;
				}
			});
			this.registrationNumber++;

			if (scriptToAdd) {
				//Adding the script to the document so they will run
				var newScriptNode = document.createElement("script");
				newScriptNode.textContent = scriptToAdd;
				document.head.appendChild(newScriptNode);
			}
		}
	},

	_calculateTotal() {
		var sum = 0;
		$("[data-component='singleRegistration']").each((index, singleRegistration) => {
			var $singleRegistration = $(singleRegistration);
			var $firstSelectedPriceOption = $singleRegistration.find("[data-component='singleRegistrationPriceCode.selector']").first().find("option:selected");
			var isCouplePrice = ($firstSelectedPriceOption.attr("data-price-type") || this.initialPriceType) === "couple";
			var multiplier = isCouplePrice ? 2 : 1;
			var pricePerPerson = Number($firstSelectedPriceOption.attr("data-price") || this.initialPrice) || 0;

			sum += (multiplier * pricePerPerson);
			$singleRegistration.find("[data-component='eventRegistrationSessions.singleCheckbox.input']:checked").each((inputIndex, element) => {
				sum += Number($(element).val()) || 0;
			});
		});

		$("[data-dynamic='RegistrationTotal'][data-dynamic-property='eventProperty']").each((index, element) => $(element).text(ActionsHelper.formatAmount(sum, $(element))));
	},

	_clearRegistrationData($singleRegistration, formParentId, shouldDefaultValues) {
		$singleRegistration.find("input:not([data-component='eventRegistrationSessions.singleCheckbox.input'])").not("input[data-parent-form-component='accountDemographicsForm']").val("");
		$singleRegistration.find("input:visible,select:visible").prop("disabled", false);
		window.AccountActions.setSelectedCountry(formParentId, window.AccountStore.getDefaultCountry());
		window.AccountActions.setSelectedState(formParentId, "");
		window.AccountActions.setSelectedTitle(formParentId, "");
		window.AccountActions.setSelectedPhoneType(formParentId, "");
		window.AccountActions.setSelectedEmailType(formParentId, "");
		ValidationHelper.removeBetterValidationPopup($singleRegistration.find("input,select").removeClass("invalid"));

		$singleRegistration.find("input[data-parent-form-component='accountDemographicsForm']").prop("checked", false);
		$singleRegistration.find("[data-component='accountDemographicsForm'] [name].isDirty").removeClass("isDirty");

		var $selectInputs = $singleRegistration.find("select[data-parent-form-component='accountDemographicsForm']");
		if (shouldDefaultValues) {
			$selectInputs.each((index, element) => {
				var $selectInput = $(element);
				var defaultValue = $selectInput.closest("[data-component='select']").attr("data-code-type-default-value") || "";
				$selectInput.val(defaultValue);

				if (defaultValue) {
					$selectInput.addClass("isDirty");
				}
			});
		} else {
			$selectInputs.val("");
		}

		$singleRegistration.find("[data-component='createAccountForm'] form")
			.removeAttr(Constants.ADDRESS_VERIFICATION_STATUSES_ATTRIBUTES.VERIFIED)
			.removeAttr(Constants.ADDRESS_VERIFICATION_STATUSES_ATTRIBUTES.USER_CERTIFIED)
			.removeAttr(Constants.ADDRESS_VERIFICATION_STATUSES_ATTRIBUTES.ERROR);
	},

	_getEventOrReturn: function(event, isDesignModeMessage, isDesignMode) {
		return ActionsHelper.getEventOrReturn(event, isDesignMode != null ? isDesignMode : window.CheckoutActions.isDesignMode(), isDesignModeMessage, /*preventDefaultInDesignMode*/false); //coersion, because we want to check for null or undefined
	},

	_getNewPriceCodeDescription: function($singlePriceSelector, newPrice) {
		var $singleRegistrationPriceCodeDiv = $singlePriceSelector.parents("[data-component='singleRegistrationPriceCode']");

		var priceSeparator = $singleRegistrationPriceCodeDiv.attr("data-price-separator");
		var pricePosition = $singleRegistrationPriceCodeDiv.attr("data-price-position");
		var displayPrice = ActionsHelper.formatAmount(newPrice, $singleRegistrationPriceCodeDiv)

		var priceDescription = $singlePriceSelector.html();
		if (pricePosition === "after") {
			if (priceSeparator === "hyphen") {
				//Find the hyphen and remove the price which is two characters past the hyphen
				priceDescription = priceDescription.substring(0, priceDescription.lastIndexOf("-") + 2);
			} else if (priceSeparator === "parentheses") {
				//Find the first parentheses and remove everything past it
				priceDescription = priceDescription.substring(0, priceDescription.lastIndexOf("("));
				displayPrice = "(" + displayPrice + ")";
			}
			priceDescription += displayPrice;
		} else if (pricePosition === "before") {
			if (priceSeparator === "hyphen") {
				//Find the hyphen and keep only it and everything past it
				priceDescription = priceDescription.substring(priceDescription.lastIndexOf("-") - 1);
			} else if (priceSeparator === "parentheses") {
				//Find the last parentheses and keep only everything past it
				priceDescription = priceDescription.substring(priceDescription.lastIndexOf(")") + 1);
				displayPrice = "(" + displayPrice + ")";
			}
			priceDescription = displayPrice + priceDescription;
		}

		return priceDescription;
	},

	_getReactScriptForSingleRegistration: function(singleEventRegistrationHtml) {
		var $reactComponents = $(singleEventRegistrationHtml).find(".isReactComponent");
		var reactScripts = ($("html").find("script").filter((index, element) => element.outerHTML.includes($reactComponents.attr("id")))[0] || {}).innerHTML;

		//Find the react scripts we need to rerun when adding
		if (reactScripts) {
			reactScripts = reactScripts.split(/[\r\n]+/);
			var reactScriptsForSingleRegistration = reactScripts.filter(singleLineScript => {
				var foundScript = false;
				singleLineScript = (singleLineScript || "");
				$reactComponents.each((index, element) => {
					foundScript = foundScript || singleLineScript.includes(element.id);
				});
				return foundScript;
			});
			this.registrationNumber = 1;
			return reactScriptsForSingleRegistration;
		}
		return null;
	},

	_priceCodeChange: function($element, $singleRegistration) {
		var $parentSingleRegistration = $singleRegistration || $element.closest("[data-component='singleRegistration']");
		var $eventRegistration = $parentSingleRegistration.closest("[data-component='eventRegistration']");
		var $spouseRegistration = $parentSingleRegistration.find("[data-component='spouseRegistration']");
		var $option = $element.find(`option[value="${$element.val()}"]`);
		var priceType = $option.attr("data-price-type") || this.initialPriceType;

		var $allCheckedCheckboxInputs = $eventRegistration.find("input[data-component='thisIsMeCheckbox.input']:checked");
		var $thisIsMeInputs = $parentSingleRegistration.find("input[data-component='thisIsMeCheckbox.input']");
		var currentRegistrantNumber = Number($parentSingleRegistration.attr("data-registrant-number"));
		var $singleRegistrationsWithVisibleSpouseRegistration = $allCheckedCheckboxInputs.not($thisIsMeInputs).closest("[data-component='singleRegistration']").filter((index, element) => {
			var $priceCodeSelector = $(element).find("[data-component='singleRegistrationPriceCode.selector']");
			return ($priceCodeSelector.length && $priceCodeSelector.has("option[data-price-type=couple]:selected").length) || this.initialPriceType === "couple";
		});
		var minimumSpouseThisIsMeCheckboxChecked = Number($singleRegistrationsWithVisibleSpouseRegistration.first().attr("data-registrant-number"));
		var $firstSpouseThisIsMeSingleRegistrationThatWasNotJustChanged = $(`[data-component="singleRegistration"][data-registrant-number="${minimumSpouseThisIsMeCheckboxChecked}"]`);

		if (priceType == "couple") {
			$spouseRegistration.show();

			if ($thisIsMeInputs.is(":checked")) {
				//If thisIsMe is checked,
				if (currentRegistrantNumber > minimumSpouseThisIsMeCheckboxChecked) {
					//If this is not first one, disable fields
					this._setFieldDisableStatus($parentSingleRegistration, "spouse", /*isDisabled*/ true);
				} else {
					//If this is the first one, enable fields and disable next visible one's fields
					this._setFieldDisableStatus($parentSingleRegistration, "spouse", /*isDisabled*/ false);
					this._setFieldDisableStatus($firstSpouseThisIsMeSingleRegistrationThatWasNotJustChanged, "spouse", /*isDisabled*/ true);
				}

				//If update is not allowed, we should set the fields to disabled
				if (!this.spouseUpdateAllowed) {
					this._setFieldDisableStatusInForm($parentSingleRegistration, "spouse", /*isDisabled*/ true);
				}

				this._setEmailFieldAsDisabled($parentSingleRegistration.find("[data-component='individualRegistration']"), $parentSingleRegistration.find("[data-component='spouseRegistration']"));
			} else {
				//If thisIsMe is NOT checked, make sure fields are enabled
				this._setFieldDisableStatus($parentSingleRegistration, "spouse", /*isDisabled*/ false);
			}
		} else {
			$spouseRegistration.hide();

			if ($thisIsMeInputs.is(":checked")) {
				//If thisIsMe is checked.
				//If this is the first one, enable next visible one's fields
				this._setFieldDisableStatus($firstSpouseThisIsMeSingleRegistrationThatWasNotJustChanged, "spouse", /*isDisabled*/ false);

				//If update is not allowed, we should set the fields to disabled
				if (!this.spouseUpdateAllowed) {
					this._setFieldDisableStatusInForm($firstSpouseThisIsMeSingleRegistrationThatWasNotJustChanged, "spouse", /*isDisabled*/ true);
				}

				this._setEmailFieldAsDisabled($firstSpouseThisIsMeSingleRegistrationThatWasNotJustChanged.find("[data-component='individualRegistration']"), $firstSpouseThisIsMeSingleRegistrationThatWasNotJustChanged.find("[data-component='spouseRegistration']"));
			}
			//If thisIsMe is NOT checked, it doesn't really matter if the fields are enabled.
		}

		//If there are any other price code selects on the page, making sure they all match in value.
		$parentSingleRegistration.find("[data-component='singleRegistrationPriceCode'] select").not($element).each((otherSelectIndex, otherSelectElement) => {
			otherSelectElement.value = $element.val();
		});
		this._setClientDynamicData($parentSingleRegistration, $option);
		this._calculateTotal();
	},

	_resetIdsForRepeatedComponents($singleRegistration) {
		$singleRegistration = $($singleRegistration || {});

		var $body = $("body");

		var $components = $singleRegistration.find("[data-repeated-id][id]").addBack($singleRegistration);
		$components.each((index, element) => {
			var newId = HtmlHelper.getId($body);
			element.setAttribute("id", newId);
		});

		var $componentsWithLinkedLabels = $singleRegistration.find(
			"[data-component='radioButtons.singleRadioButton.input']," +
			"[data-component='singleCheckbox.input']," +
			"[data-component='multipleCheckboxes.singleCheckbox.input']"
		);
		$componentsWithLinkedLabels.each((index, element) => {
			var $element = $(element);

			$element
				.closest(
					"[data-component='radioButtons.singleRadioButton']," +
					"[data-component='singleCheckbox']," +
					"[data-component='multipleCheckboxes.singleCheckbox']"
				)
				.find("[data-component='label']")
				.attr("for", $element.attr("id"));
		});
	},

	_serializeEmailAddress(data, $singleRegistration) {
		var isThisIsMeChecked = Boolean($singleRegistration.find("[data-component='thisIsMeCheckbox.input']:checked").length);
		//Have to do email addresses differently because they are always disabled when thisIsMe is Checked
		if (isThisIsMeChecked) {
			if (data.individual) {
				var $individualEmailAddress = $singleRegistration.find("[data-component='individualRegistration'] [data-component='accountEmailAddress']");
				if ($individualEmailAddress.length && $individualEmailAddress.val()) {
					data.individual.email = data.individual.email || {};
					data.individual.email.emailAddress = $individualEmailAddress.val();
				}
			}

			if (data.spouse) {
				var $spouseEmailAddress = $singleRegistration.find("[data-component='spouseRegistration'] [data-component='accountEmailAddress']");
				if ($spouseEmailAddress.length && $spouseEmailAddress.val()) {
					data.spouse.email = data.spouse.email || {};
					data.spouse.email.emailAddress = $spouseEmailAddress.val();
				}
			}
		}

		return data;
	},

	_serializeSingleRegistration($singleRegistration, serializeDemographics) {
		var data = {};
		//Save previously entered data
		var $individualRegistration = $singleRegistration.find("[data-component='individualRegistration']");
		var $spouseRegistration = $singleRegistration.find("[data-component='spouseRegistration']");

		data.individual = ActionsHelper.serializeForm($individualRegistration.find("form#createAccountForm"));
		data.spouse = ActionsHelper.serializeForm($spouseRegistration.find("form#spouseInformationForm"));

		//Initialize Codes so property is never empty
		data.individual.codes = [];
		data.spouse.codes = [];

		if (serializeDemographics) {
			AccountFormHelper.updateAccountDemographics(data.individual, $individualRegistration, /* shouldValidate */ false);
			AccountFormHelper.updateAccountDemographics(data.spouse, $spouseRegistration, /* shouldValidate */ false);
		}

		data = this._serializeEmailAddress(data, $singleRegistration);
		data.individual.savedFormData = true;
		data.spouse.savedFormData = true;

		return data;
	},

	_setAccountData(data, $component, formId) {
		//This is the first checkbox input.  If we have account data, set it.
		if (data) {
			this._setTextInput($component, "accountFirstName", data.firstName);
			this._setTextInput($component, "accountLastName", data.lastName);
			this._setTextInput($component, "accountMiddleName", data.middleName);
			this._setTextInput($component, "accountMiddleName", data.middleName);
			this._setTextInput($component, "accountSuffix", data.suffix);
			window.AccountActions.setSelectedTitle(formId, data.title);
			if (data.address) {
				this._setTextInput($component, "accountAddressLine1", data.address.line1);
				this._setTextInput($component, "accountAddressLine2", data.address.line2);
				this._setTextInput($component, "accountAddressLine3", data.address.line3);
				this._setTextInput($component, "accountAddressLine4", data.address.line4);
				this._setTextInput($component, "accountAddressCity", data.address.city);
				this._setTextInput($component, "accountAddressPostalCode", data.address.postalCode);
				window.AccountActions.setSelectedCountry(formId, data.address.country || window.AccountStore.getDefaultCountry());
				window.AccountActions.setSelectedState(formId, data.address.state);
			}
			if (data.phone) {
				this._setTextInput($component, "accountPhoneCountryCode", data.phone.internationalCode);
				this._setTextInput($component, "accountPhoneAreaCode", data.phone.areaCode);
				this._setTextInput($component, "accountPhoneNumber", data.phone.phoneNumber);
				this._setTextInput($component, "accountPhoneExtension", data.phone.extension);
				window.AccountActions.setSelectedPhoneType(formId, data.phone.type);
			}
			if (data.email) {
				window.AccountActions.setSelectedEmailType(formId, data.email.type);
				this._setTextInput($component, "accountEmailAddress", data.email.emailAddress);
			}
			window.AccountActions.initializeDemographics({
				accountCodes: data.codes,
				parentSelector: $component,
				setInitialDirty: data.savedFormData
			});
			ValidationHelper.removeBetterValidationPopup($component.find("input,select").removeClass("invalid"));
		}
	},

	_copyDemographics: function($sourceComponent, $targetComponent) {
		if ($sourceComponent.length <= 0 || $targetComponent.length <= 0) {
			//There is no source component to copy from or target component to copy to
			return;
		}

		var $elements = $sourceComponent.find(
			"select[data-parent-form-component='accountDemographicsForm']," +
			"input[data-parent-form-component='accountDemographicsForm']:checkbox," +
			"input[data-parent-form-component='accountDemographicsForm']:radio"
		);

		$elements.each(function(index, demographic) {
			var $demographic = $(demographic);
			var name = $demographic.attr("name");
			var value = $demographic.val();
			var fieldComponentName = $demographic.closest("[data-component]").attr("data-component");

			switch (fieldComponentName) {
				case "select.input":
					$targetComponent.find(`[data-component="${fieldComponentName}"][name="${name}"]`).val(value);
					break;
				case "radioButtons.singleRadioButton.input":
					var shouldCheck = $demographic.prop("checked");
					$targetComponent.find(`[data-component="${fieldComponentName}"][name="${name}"][value="${value}"]`).prop("checked", shouldCheck);
					break;
				case "singleCheckbox.input":
					var shouldCheck = $demographic.prop("checked");
					$targetComponent.find(`[data-component="${fieldComponentName}"][name="${name}"]`).prop("checked", shouldCheck);
					break;
				case "multipleCheckboxes.singleCheckbox.input":
					var shouldCheck = $demographic.prop("checked");
					$targetComponent.find(`[data-component="${fieldComponentName}"][name="${name}"][value="${value}"]`).prop("checked", shouldCheck);
					break;
				default:
					break;
			}
		});
	},

	_setClientDynamicData: function($singleRegistration, $selectedOption) {
		if (!$selectedOption || !$selectedOption.length) {
			var $priceCodeSelector = $singleRegistration.find("[data-component='singleRegistrationPriceCode']").first().find("select");
			$selectedOption = $priceCodeSelector.find(`option[value="${$priceCodeSelector.val()}"]`);
		}

		var price = $selectedOption.attr("data-price") || this.initialPrice;
		var priceDescription = $selectedOption.attr("data-price-description") || this.initialPriceDescription;
		var registrantNumber = $singleRegistration.attr("data-registrant-number") || "";

		$singleRegistration.find("[data-dynamic='Price'][data-dynamic-property='eventSingleRegistrationProperty']").each((index, priceElement) => {
			var $priceElement = $(priceElement);
			$priceElement.text(ActionsHelper.formatAmount(price, $priceElement));
		});

		$singleRegistration.find("[data-dynamic='PriceDescription'][data-dynamic-property='eventSingleRegistrationProperty']").text(priceDescription);
		$singleRegistration.find("[data-dynamic='RegistrantNumber'][data-dynamic-property='eventSingleRegistrationProperty']").text(registrantNumber);
	},

	_setEmailFieldAsDisabled($individualRegistration, $spouseRegistration) {
		//EmailAddress Field are always disabled when we are identified or logged in because we do not want the constituent's username to change
		//	When we are identified or logged in, we will have this.accountData or this.spouseData
		//	If, for some reason, we do not have an email address, let us go ahead and enter one.  This would mainly be for the spouseAccount, I would imagine.
		if (this.accountData && this.accountData.email && this.accountData.email.emailAddress) {
			$individualRegistration.find("input[data-component='accountEmailAddress']").prop("disabled", true);
		}
		if (this.spouseData && this.spouseData.email && this.spouseData.email.emailAddress) {
			$spouseRegistration.find("input[data-component='accountEmailAddress']").prop("disabled", true);
		}
	},

	_setFieldDisableStatus($singleRegistration, type, isDisabled) {
		this._setFieldDisableStatusInternal($singleRegistration, type, /*shouldRestrictToForm*/ false, isDisabled);
	},

	_setFieldDisableStatusInForm($singleRegistration, type, isDisabled) {
		this._setFieldDisableStatusInternal($singleRegistration, type, /*shouldRestrictToForm*/ true, isDisabled);
	},

	_setFieldDisableStatusInternal($singleRegistration, type, shouldRestrictToForm, isDisabled) {
		var formSelector = "";
		if (shouldRestrictToForm) {
			var componentName = type === "individual" ? "createAccountForm" : "spouseInformation";
			formSelector = `[data-component="${componentName}"] `;
		}

		var $fieldsToToggle = $singleRegistration
			// Find all input and select elements within the createAccountForm/spouseInformation component that are not
			// the This Is Me checkbox, the Event Registration Session checkbox, or the Registration Price Code selector
			.find(
				`[data-component="${type}Registration"] ${formSelector}input:not([data-component="thisIsMeCheckbox.input"],[data-component="eventRegistrationSessions.singleCheckbox.input"]),` +
				`[data-component="${type}Registration"] ${formSelector}select:not([data-component="singleRegistrationPriceCode.selector"])`
			);

		$fieldsToToggle.prop("disabled", isDisabled);
	},

	_setTextInput($parent, childComponentName, value) {
		$parent.find(`input[data-component="${childComponentName}"]`).val(value || "");
	},

	_updateAllPrices() {
		var $registrations = $("[data-component='singleRegistration']");

		//Update dynamic data for events
		$registrations.each((index, singleRegistration) => {
			var $priceCodeSelectors = $(singleRegistration).find("[data-component='singleRegistrationPriceCode.selector']");
			$priceCodeSelectors.each((index, priceCodeSelector) => {
				this._priceCodeChange($(priceCodeSelector), $(singleRegistration));
			});
		});

		//Update the registration template so that new registrants include the group code pricing
		var $registrationTemplate = $("[data-component='singleRegistration']").first().attr("data-registrant-number", 1);
		if ($registrationTemplate[0]) {
			this.singleEventRegistrationHtml = $registrationTemplate[0].outerHTML;
		}
	},

	_updateGroupCodeUi(groupCode, data) {
		$("[data-component='applyGroupCodeForm']").attr("group-code", groupCode);
		$("[data-component='applyGroupCodeForm']").attr("group-code-price-code", data.defaultPriceCode);

		//If there is a current groupCode component, set the label
		var $groupCodeDynamicLabel = $("[data-dynamic-property='groupCode']");

		$groupCodeDynamicLabel.each((index, groupLabel) => {
			var $groupLabel = $(groupLabel)
			var $links = $groupLabel.find("a");

			//Check to see if there are any links in the label - if so, update their html
			if ($links.length) {
				$links.each((index, element) => {
					var $element = $(element);

					$element.html(groupCode);
				});
			}
			else {
				$groupLabel.html(groupCode);
			}
		});

		$("[data-component='currentGroupCode']").show();

		var $registrationTypes = $("[data-component='singleRegistrationPriceCode.selector'] option");

		//Update each registration drop-down with the new price
		$registrationTypes.each((index, singlePriceSelector) => {
			var $singlePriceSelector = $(singlePriceSelector);
			var newPriceDescription = this._getNewPriceCodeDescription($singlePriceSelector, data.newPrice);

			//Save the old price if needed
			if (!$singlePriceSelector.attr("data-old-price")) {
				$singlePriceSelector.attr("data-old-price", $singlePriceSelector.attr("data-price"));
			}

			$singlePriceSelector.html(newPriceDescription);
			$singlePriceSelector.attr("data-price", data.newPrice);
		});
	}
};

module.exports = EventRegistrationHelper;
